import React from 'react';
import {
  Skeleton,
  SkeletonBlock,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';

export const SkeletonLoader = () => {
  return (
    <Skeleton className="sui-grow" data-testid="skeleton-loader">
      <SkeletonBlock aspect="wide" />
      <div className="sui-w-40">
        <SkeletonLine numberOfLines={3} />
      </div>
    </Skeleton>
  );
};
